export const APP_NAME = 'Wasabi（ワサビ）'